module.exports = __webpack_public_path__ + "img/ic_food_manage_bottom_item_img2.8ea91920.png";